import React from 'react';

const GoalModal = ({ show, onClose, onSubmit, form, onChange, sectionOptions, courseTypeOptions }) => {
  if (!show) return null;
  return (
    <div className="modal-overlay-goal">
      <div className="modal-goal">
        <div className="modal-header-goal">Add New Goal</div>
        <form className="modal-form-goal" onSubmit={onSubmit}>
          <input
            className="modal-input-goal"
            type="text"
            name="name"
            placeholder="Goal Name"
            value={form.name}
            onChange={onChange}
            maxLength={40}
            required
          />
          <select
            className="modal-input-goal"
            name="section"
            value={form.section}
            onChange={onChange}
            required
          >
            <option value="" disabled>Section</option>
            {sectionOptions.slice(1).map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          <select
            className="modal-input-goal"
            name="courseType"
            value={form.courseType}
            onChange={onChange}
            required
          >
            <option value="" disabled>Course Type</option>
            {courseTypeOptions.slice(1).map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          <div className="modal-actions-goal">
            <button type="button" className="modal-cancel-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="add-goal-confirm-btn">Add Goal</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GoalModal;